import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import Loader from 'components/common/Loader'
import { getRoomName } from 'helpers/room'
import { useRedirector } from 'hooks/useRedirector'
import { dispatchSetRoomData } from 'store/dispatcher'
import { _isLoading } from 'store/selectors/Room'
import { _userId } from 'store/selectors/User'
import TwilioApp from 'Twilio'

const VideoApp = () => {
    const isLoading = useSelector(_isLoading)
    const userId = useSelector(_userId)

    useRedirector()

    useEffect(() => {
        if (!isLoading || !userId) return

        /**
         * >> check if user is allowed in the class
         * >> fetch room type and name
         * >> fetch twilio token, room state, user(type, gender, name)
         * >> check if this room is being recorded
         */
        const roomName = getRoomName()

        dispatchSetRoomData({ roomName, userId })
    }, [isLoading, userId])

    console.count('VideoApp component')

    if (isLoading) return <Loader overlay />

    return <TwilioApp />
}

export default VideoApp
